import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { NotificationsService } from 'angular2-notifications';

import { ResourcesService } from '../../../../services/resources/resources.service';
import { EventsService } from '../../../../services/events/events.service';
import { SERVICES_URLS } from '../../../../services/resources/services.urls';
import { LocalStorageService } from 'ngx-webstorage';

import * as moment from 'moment-timezone';

@Component({
  selector: 'modal-edit-user',
  styleUrls: [('./modalEditUser.scss')],
  templateUrl: './modalEditUser.html'
})

export class ModalEditUser {
  @ViewChild('form') form;
  modalHeader: string;
  survey;
  folder: string = "";
  loading: Boolean;
  change_password: Boolean;
  change_checkbox;
  private fileList: FileList;
  private user: string = "";
  private base64textString: String = "";

  constructor(
    private activeModal: NgbActiveModal,
    private _notificationService: NotificationsService,
    private _resourcesService: ResourcesService,
    private _element: ElementRef,
    private _localStorage: LocalStorageService,
    private _eventsService: EventsService
  ) {
    var user = _localStorage.retrieve('user_data');
    if (user != null)
      this.user = user;

    console.log(user);

    _localStorage.observe('user_data')
      .subscribe((token) => this.user = token);

    this.change_password = false;
    this.change_checkbox = false;
    this.survey = {
      id: '',
      first_name: '',
      last_name: '',
      email: '',
      username: '',
      password: '',
      is_admin: false,
      read_only_permission: false,
      is_active: true
    };
  }

  ngOnInit() { }

  public closeModal() {
    this.activeModal.close();
  }

  public changePassword(e) {
    console.log(e.target.checked);
    this.change_password = e.target.checked;
  }

  public addPersonal() {
    if(!this.change_password){
    this._resourcesService.editUser(this.survey.id,this.survey)
      .subscribe(
      result => this.saveSurvey(result),
      error => this.showError(error)
      );
      }else{
    this._resourcesService.editUserPassword(this.survey.id,this.survey)
      .subscribe(
      result => this.saveSurvey(result),
      error => this.showError(error)
      );
      }
  }

  private showError(error) {
    console.log(error)
    this._notificationService.error('Mensaje', 'Error con los datos ingresados.');
  }

  private saveSurvey(survey) {
    this._eventsService.setObjectCrud(survey);
    this.activeModal.close();
  }

  public selectFile() {
    this.base64textString = null;
  }


  public fileChange(event) {
    var files = event.target.files;
    var file = files[0];

    if (files && file) {
      var reader = new FileReader();

      reader.onload = this._handleReaderLoaded.bind(this);

      reader.readAsBinaryString(file);
    }
  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    //console.log(this.base64textString);
  }

  private setImportedData(data) {
    this.survey.imagen_personal = "";
    this._resourcesService.addPersonal(this.survey)
      .subscribe(
      result => this.saveSurvey(result),
      error => this.showError(error)
      );
  }

  setUser(user) {
    this.survey = user;
  }
  //this.localStorage.store('imported_points', resultToAdd);
  //this.localStorage.store('resolved_points', resultToAddRes);
  //this.importedPoints = resultToAdd.concat(resultToAddRes);

  private getDataError(error) {
    console.log(error);
    this.loading = false;
    //this.localStorage.store('imported_points', []);
    //this.localStorage.store('resolved_points', []);
    this.form.nativeElement.reset();
    this._notificationService.error('Mensaje', 'Error al importar puntos de visita.');
  }
}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalEditUser/modalEditUser.component.ts